module.exports = __webpack_public_path__ + "resources/img/2@3x.a0c082fa.png";